import React, { useContext } from 'react';
import Icon from '../../assets/icons/icon';
import { useSelector, useDispatch } from 'react-redux';
import * as images from '../../assets/icons/carrier_logos/index';
import { handleSelectedProducts, sendLeadToNavigator } from '../../utilities/virtualMentor';
import { setLoadingGif } from '../../features/loadingSlice';
import { AgentContext } from '../../context/AgentContext';

function ReccomendationBlock({from,reccomendation, setSelectedProducts, setExtraInfo, possibleConditions, faceAmount, selectedProducts, checkVisibility=false}) {

    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const isFeature133Enabled = process.env.REACT_APP_FUNNEL_FEATURE_133 === 'true'
    const agentInfo=useSelector((state) => state.agent.userData);
    const dispatch = useDispatch()

    async function sendToNavigator(lead) {
        if(isB2B){
            const url = agentInfo.navigator_sso ?? process.env.REACT_APP_NAVIGATOR_FALLBACK_URL
            window.open(url, "_blank");
        } else {
            if(isFeature133Enabled === true){
                dispatch(setLoadingGif(true));
                const navAgentClientUrl = await sendLeadToNavigator(agentInfo.agentCode, agentInfo.email, lead.lead_code, lead.borrower_age, lead.borrower_sex, dispatch, agentInfo.agentId)

                if(navAgentClientUrl === null){
                    window.open(process.env.REACT_APP_NAVIGATOR_FALLBACK_URL, "_blank");
                } else {
                    window.open(navAgentClientUrl, "_blank");
                }
            } else {
                window.open(process.env.REACT_APP_NAVIGATOR_FALLBACK_URL, "_blank");
            }
        }
    }
    const checkSelected = (tempId) => {
        if(selectedProducts){
            return selectedProducts.some(item => item.product.tempId === tempId);
        }
        else{
            return false;
        }
    };

    const currencyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    const {isB2B} = useContext(AgentContext)
    return (
        <div className={`recBlock ${checkSelected(reccomendation.tempId) && 'selectedRec'}`} onClick={()=> from==='script' ? null : handleSelectedProducts(faceAmount,reccomendation,setSelectedProducts)}>
            <div className="recTop">
                <div className="recLogoHolder">
                <img src={images.default[`${reccomendation.organization}`]} className="recLogo" />
                </div>
                <div className="recTitle">{reccomendation.name}</div>
                {reccomendation.quote ? (
                    <div className="recQuote">{currencyFormatter.format(reccomendation.quote.MonthlyPremium)}</div>
                ) : (
                    <div className="shimmer" style={{width: '10%', height: '50%', margin: 'auto'}}></div>
                )}

            </div>
            <div className="recBottom">
                <div className="recLink outlineQuilityActiveButton" onClick={(e)=>[setExtraInfo(reccomendation),e.stopPropagation()]}>
                    <a className="noDeco">Info</a>
                </div>
                <div className={`recLink ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`}>
                    {reccomendation.application_url === 'https://dynamic-advisor-prod.techf.com/login?org=org_VXB5UCMciyy4LpyU&connection=QuilitySSO' ? (
                        <span onClick={()=>sendToNavigator(leadsAlldata)}>Apply <span className="fontello" style={{lineHeight: '12px'}}><Icon name={'link-external-q'} size={14} height="22" adjust="fontello" /></span></span>
                    ) : (
                        <a className="noDeco" href={reccomendation.application_url} target='_blank'>Apply <span className="fontello" style={{lineHeight: '12px'}}><Icon name={'link-external-q'} size={14} height="22" adjust="fontello" /></span></a>
                    )}

                </div>
                <div className={`recLink ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`}>
                    <a className="noDeco" href={reccomendation.quote_url} target='_blank'>Quote <span className="fontello" style={{lineHeight: '12px'}}><Icon name={'link-external-q'} size={14} height="22" adjust="fontello" /></span></a>
                </div>
            </div>
        </div>
    );
}

export default ReccomendationBlock;